import { RoundsCore } from '../../../../core/collections';

export default class Rounds extends RoundsCore {
	initialize(){
		this.prefix = 'nrl/';
		this.url = `rounds.json?_=${Date.now()}`;
	}
}